import { render, staticRenderFns } from "./BrowserOverlay.vue?vue&type=template&id=a5b06d62&scoped=true"
import script from "./BrowserOverlay.vue?vue&type=script&lang=js"
export * from "./BrowserOverlay.vue?vue&type=script&lang=js"
import style0 from "./BrowserOverlay.vue?vue&type=style&index=0&id=a5b06d62&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b06d62",
  null
  
)

export default component.exports